import { Autocomplete, MenuItem, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { api } from '../api/client';
import type { SearchRegion } from '../api/types';
import type { VolumeContext } from '../../../api/src/fakes/volume-context';

export function FakesVolumeWordstatFields({
  workspaceId,
  context,
  disabled,
  onChange,
}: {
  workspaceId: string;
  context: Extract<VolumeContext, { source: 'wordstat' }> | null;
  disabled: boolean;
  onChange(context: Extract<VolumeContext, { source: 'wordstat' }> | null): void;
}) {
  const [query, setQuery] = useState('');
  const [text, setText] = useState<string | null>(null);
  const [options, setOptions] = useState<SearchRegion[]>([]);
  const [error, setError] = useState('');
  const [device, setDevice] = useState<'desktop' | 'mobile'>(context?.device ?? 'desktop');
  useEffect(() => {
    let cancelled = false;
    const timer = window.setTimeout(() => {
      api.searchYandexRegions(workspaceId, query).then(
        (result) => {
          if (!cancelled) {
            setOptions(result.items);
            setError('');
          }
        },
        (error) => {
          if (!cancelled)
            setError(error instanceof Error ? error.message : 'Не удалось загрузить регионы');
        },
      );
    }, 250);
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [workspaceId, query]);
  const region = context ? { code: context.regionCode, name: context.regionName } : null;
  return (
    <>
      <Autocomplete
        disabled={disabled}
        value={region}
        inputValue={text ?? (region ? `${region.name} (${region.code})` : '')}
        options={
          region && !options.some((item) => item.code === region.code)
            ? [region, ...options]
            : options
        }
        filterOptions={(items) => items}
        getOptionLabel={(item) => `${item.name} (${item.code})`}
        isOptionEqualToValue={(a, b) => a.code === b.code}
        noOptionsText="Регион не найден"
        onInputChange={(_, value, reason) => {
          if (reason === 'input') {
            setQuery(value);
            setText(value);
            onChange(null);
          }
        }}
        onChange={(_, value) => {
          setText(null);
          onChange(
            value
              ? {
                  source: 'wordstat',
                  regionCode: value.code,
                  regionName: value.name,
                  device: context?.device ?? device,
                }
              : null,
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Регион частотности Яндекса"
            error={!!error}
            helperText={error || 'Начните вводить название или код региона.'}
          />
        )}
      />
      <TextField
        select
        label="Устройства Wordstat"
        disabled={disabled}
        value={context?.device ?? device}
        onChange={(event) => {
          const selected = event.target.value as 'desktop' | 'mobile';
          setDevice(selected);
          if (context) onChange({ ...context, device: selected });
        }}
      >
        <MenuItem value="desktop">Компьютеры</MenuItem>
        <MenuItem value="mobile">Телефоны</MenuItem>
      </TextField>
    </>
  );
}
